import { TreeType } from '../../../markdown.types';
import { IBuildTreeFromTagsOptions } from './buildTreeFromTags.types';

export const buildTreeFromTags = (opts: IBuildTreeFromTagsOptions): TreeType => {
  const { text, positionToTag, startContent, endContent, tagsPositions } = opts;
  const tree: TreeType = [];

  let innerTagPositions: string[] = [];
  let openedTag: { position: number; tag: string } | null = null;
  let currentContentStartPosition = startContent;

  for (let i = 0; i < tagsPositions.length; i++) {
    const tagPosition = parseInt(tagsPositions[i]);
    const tagData = positionToTag[tagPosition];

    if (openedTag === null) {
      if (currentContentStartPosition < tagPosition) {
        tree.push({
          tag: 'text',
          content: text.substring(currentContentStartPosition, tagPosition),
        });

        currentContentStartPosition = tagPosition;
      }

      if (tagData.keyWord) {
        tree.push({
          tag: 'keyWord',
          content: text.substring(tagData.start, tagData.end),
          props: { type: tagData.keyWord.keyWordType },
        });

        currentContentStartPosition = tagData.end;
      } else if (tagData.tag === '@') {
        tree.push({
          tag: tagData.tag,
          content: text.substring(tagData.start, tagData.end),
          props: { mention: tagData.userMention },
        });

        currentContentStartPosition = tagData.end;
      } else if (tagData.tag === '/') {
        tree.push({
          tag: tagData.tag,
          content: text.substring(tagData.start, tagData.end),
          props: {},
        });

        currentContentStartPosition = tagData.end;
      } else if (tagData.tag === 'link') {
        tree.push({
          tag: tagData.tag,
          content: tagData.link || '',
          props: { link: tagData.link || '' },
        });

        currentContentStartPosition = tagData.end;
      } else if (tagData.tag === 'email') {
        tree.push({
          tag: tagData.tag,
          content: tagData.email || '',
          props: { email: tagData.email || '' },
        });

        currentContentStartPosition = tagData.end;
      } else {
        openedTag = {
          position: tagPosition,
          tag: tagData.tag || '',
        };
      }

      continue;
    }

    if (openedTag.tag !== '[' && openedTag.tag !== tagData.tag) {
      innerTagPositions.push(tagsPositions[i]);
      continue;
    }

    if (openedTag.tag === '[' && tagData.tag !== ']') {
      innerTagPositions.push(tagsPositions[i]);
      continue;
    }

    currentContentStartPosition = tagPosition + (tagData.end - tagData.start);

    const childStartContent = openedTag.position + openedTag.tag.length;
    const childEndContent = tagPosition;

    const props: Record<string, string> = {};

    if (tagData.link !== undefined) {
      props.link = tagData.link;
    }

    if (innerTagPositions.length === 0) {
      tree.push({
        tag: openedTag.tag,
        content: text.substring(childStartContent, childEndContent),
        props,
      });
    } else {
      tree.push({
        tag: openedTag.tag,
        content: buildTreeFromTags({
          text,
          positionToTag,
          startContent: childStartContent,
          endContent: childEndContent,
          tagsPositions: innerTagPositions,
        }),
        props,
      });

      innerTagPositions = [];
    }

    openedTag = null;
  }

  if (currentContentStartPosition < endContent) {
    tree.push({
      tag: 'text',
      content: text.substring(currentContentStartPosition, endContent),
    });
  }

  return tree;
};
